/* eslint-disable @typescript-eslint/no-unused-vars */
import { ShipppingPricingSectionItem } from "@/providers/strapi/content/types/components/shipping.component";
import { useShippingPage } from "@/providers/strapi/content/types/singleTypes/shipping-page";
import * as X from "@/ui";
import ReactMarkdown from "react-markdown";

// type Localization<T> = {
//   en: T,
//   fr: T,
//   ko: T,
//   zh: T
// }

type ViewModel = {
  costs: string[]
}

// const defaultData: ViewModel = {
//   costs: [
//     {
//       en: `Compensation is based on a commission from the recovered VAT`,
//       fr: `Rémunération sous forme de commission sur la TVA remboursée`,
//       ko: `보상은 환급받은 부가세에서 수수료로 책정됩니다`,
//       zh: ""
//     },
//     {
//       en: `Between 60% and 90% of the paid VAT is progressively refunded`,
//       fr: `Remboursement progressif de 60 % à 90 % de la TVA payée`,
//       ko: `납부한 부가세의 60%에서 90%가 점진적으로 환급됩니다`,
//       zh: ""
//     },
//     {
//       en: `Service fees and shipping costs are deducted from the recovered VAT`,
//       fr: `Frais de service et coûts d’expédition déduits de la TVA récupérée`,
//       ko: `서비스 수수료 및 배송비는 환급된 부가세에서 공제됩니다`,
//       zh: ""
//     },
//     {
//       en: `If the VAT refund does not fully cover shipping, the remaining balance is billed separately`,
//       fr: `Si la TVA récupérée ne couvre pas les frais d’expédition, le complément est à votre charge`,
//       ko: `부가세 환급액이 배송비를 전액 충당하지 못할 경우, 잔액은 별도로 청구됩니다`,
//       zh: ""
//     },
//   ],
// };

const buildViewModel = (content: ShipppingPricingSectionItem[]): ViewModel => ({
  costs: content.map((c, i) => c.text)
})

export function PricingSection(props: X.PageProps) {
  // const tr = X.useTranslator<"ko">(props);
  const pricingSection = useShippingPage('pricingSection');
  const data = buildViewModel(pricingSection.content)
  return (
    <section id="pricing" className={X.clsx(
      "scroll-mt-[120px]",
      "bg-surface-blue xl:bg-transparent",
      "xl:max-w-content xl:mx-auto mb-12 xl:my-20",
    )}>
      <div className="pt-6 xl:pt-0 bg-white xl:bg-transparent pr-mobile-margin ml-mobile-margin-half pl-mobile-margin-half pb-8 xl:m-0 xl:p-0 rounded-tl-4xl">
        {/* <h2 className="text-[36px] xl:text-[48px] [&_strong]:font-medium mb-4 xl:mb-12 text-center leading-tight">
          {tr({
            en: <>What are <strong>the fees?</strong></>,
            fr: <>Quels sont <strong>les frais{X.Nbsp}?</strong></>,
            ko: <>수수료는 얼마인가요?</>,
          })}
        </h2> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h2 {...props} className="text-[36px] xl:text-[48px] [&_strong]:font-medium mb-4 xl:mb-12 text-center leading-tight" />
        }}>
          {pricingSection.title}
          {/* {tr({
            en: pricingSection.title,
            fr: pricingSection.title,
            ko: "수수료는 얼마인가요?",
            zh: ""
          })} */}
        </ReactMarkdown>
        <ul className={X.clsx(X.desktopOnly("flex"), "flex-row gap-8 mb-10")}>
          {data.costs.map((text, i) => (
            <li key={i} className={X.clsx(
              "flex flex-col min-h-[220px] justify-center items-center py-4 px-8 rounded-xl flex-1",
              getBgColor(i),
            )}>
              <div className="text-center text-[20px] leading-tight">
                {/* {tr(text)} */}
                <ReactMarkdown
                  components={{
                    p: ({ ...props }) => <>{props.children}</>
                  }}>
                  {text}
                </ReactMarkdown>
              </div>
            </li>
          ))}
        </ul>

        <div className={X.clsx(X.mobileOnly(), "flex flex-col gap-4 py-6")}>
          {X.groupBy(2, data.costs).map((pair, i) => (
            <ul key={i} className="flex flex-row gap-4">
              {pair.map((text, j) => (
                <li key={j} className={X.clsx(
                  "flex flex-col min-h-[160px] justify-center items-center py-6 px-2 rounded-xl flex-1",
                  getBgColor(i * 2 + j),
                )}>
                  <div className="text-center text-[14px] leading-tight">
                    {/* {tr(text)} */}
                    <ReactMarkdown>
                      {text}
                    </ReactMarkdown>
                  </div>
                </li>
              ))}
            </ul>
          ))}
        </div>

        {/* <p className="xl:max-w-4xl xl:mx-auto text-center text-[16px] xl:text-[18px] pb-6 xl:pb-0 leading-tight">
          {pricingSection.info}
          {tr({
            en: `A service designed to maximize your refund while keeping your logistics costs low.`,
            fr: `Un service pensé pour maximiser votre remboursement tout en réduisant vos coûts logistiques.`,
            ko: `물류 비용을 낮추는 동시에 환불을 극대화하도록 설계된 서비스입니다.`,
          })}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="xl:max-w-4xl xl:mx-auto text-center text-[16px] xl:text-[18px] pb-6 xl:pb-0 leading-tight" />,
        }}>
          {pricingSection.info}
        </ReactMarkdown>

        <div className="flex flex-col items-center xl:mt-10">
          <X.Button
            primary lg
            className="X-Open-Intercom"
            // label={tr({
            //   en: pricingSection.cta,
            //   fr: pricingSection.cta,
            //   ko: "문의하기",
            //   zh: ""
            // })}
            label={pricingSection.cta}
          // label={tr({
          //   en: "Contact us",
          //   fr: "Contactez-nous",
          //   ko: "문의하기",
          // })}
          />
        </div>
      </div>
    </section>
  );
}


function getBgColor(index: number) {
  return (
    index === 0 ? "bg-surface-green" :
      index === 1 ? "bg-[#c1fde7]" :
        index === 2 ? "bg-[#a8fcde]" :
          "bg-[#8ffbd4]"
  );
}
